import useSWR from "swr";
import { fetcher, poster, puter } from "@api/_base";
import { getFilterQuery, getPageQuery } from "@api/products/_utils";
import { composeQueryParams } from "@utils/query.utils";
import {
  ProductReviewResponse,
  ReviewSummaryResponse,
  AddReviewDTO,
  ReviewDisplayConfig,
  OrdersReviewResponse,
} from "@interfaces/dto/review.dto";
import { API_MESSAGE } from "@const/api-messages.const";
import { ApiResponse } from "@interfaces/dto/swr.dto";
import { REVIEW_DEFAULT_PAGE, REVIEW_PAGE_SIZE } from "@const/products.const";

export const useReviewProduct = ({
  productId,
  productDisplayConfig,
  ratingStar,
  filterImage
}: {
  productId: string | undefined;
  productDisplayConfig: ReviewDisplayConfig;
  ratingStar: string | undefined;
  filterImage: string | undefined;
}): ProductReviewResponse => {
  let query: string | undefined = undefined;

  // require productId
  if (productId) {
    const queryProduct = getFilterQuery({
      field: "product_id",
      value: productId,
      layer: 0,
    });

    //filter status
    const queryStatus = getFilterQuery({
      field: "status_id",
      value: "1",
      layer: 1,
    });

    //filter star
    let queryStar: string | undefined;
    if (ratingStar) {
      queryStar = getFilterQuery({
        field: "rating_star",
        value: ratingStar,
        layer: 2,
      });
    }

    //filter image
    let queryImage: string | undefined;
    if (filterImage) {
      queryImage = getFilterQuery({
        field: "filter_image",
        value: filterImage,
        layer: 3,
      });
    }

    // [page]
    const { pageSize, currentPage } = productDisplayConfig || { pageSize: REVIEW_DEFAULT_PAGE, currentPage: REVIEW_PAGE_SIZE };;
    const queryPage = getPageQuery({
      pageSize: pageSize,
      currentPage: currentPage,
    });

    const filterQueries = [queryProduct, queryStatus, queryStar, queryImage, queryPage].filter(Boolean);
    query = composeQueryParams(filterQueries);

  }

  const { data, error, mutate } = useSWR(
    query
      ? `/nextapi/reviews?${query}&searchCriteria[sortOrders][0][field]=created_at&searchCriteria[sortOrders][0][direction]=DESC`
      : undefined,
    fetcher
  );

  // if (data) {
  //   console.log("Review Data from API:", data);
  // }

  // if (error) {
  //   console.error("Review API Error:", error);
  // }

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

export const useRatingSummary = ({
  productId,
}: {
  productId: string | undefined;
}): ReviewSummaryResponse => {
  let query: string | undefined = undefined;

  // require productId
  if (productId) {
    const queryProduct = getFilterQuery({
      field: "product_id",
      value: productId,
      layer: 0,
    });

    query = composeQueryParams([queryProduct]);
  }

  const { data, error, mutate } = useSWR(
    query ? `/nextapi/reviews/${productId}` : undefined,
    fetcher
  );

  // if (data) {
  //   console.log("data summary from API:", data);
  // }

  // if (error) {
  //   console.error("Rating API Error:", error);
  // }

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

export const useOrderReview= (
  customerId: string | undefined,
): OrdersReviewResponse => {
  
  const { data, error, mutate } = useSWR(
    customerId
      ? `/nextapi/order/reviews?searchCriteria[filterGroups][0][filters][0][field]=customer_id&searchCriteria[filterGroups][0][filters][0][value]=${customerId}&searchCriteria[sortOrders][0][field]=created_at&searchCriteria[sortOrders][0][direction]=DESC`
      : undefined,
    fetcher
  );

  // if (data) {
  //   console.log("data order review from API:", data);
  // }

  // if (error) {
  //   console.error("data order review API Error:", error);
  // }

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

export const updateStatusOrderReview = async (
  item_id: any,
): Promise<ApiResponse> => {
  try {
    await puter(`/nextapi/reviews/item/${item_id}`);
    return { isOk: true, message: "เปลี่ยนสถานะแล้ว" };
  } catch (error: any) {
    const errorMessage: string =
      error.response.data.message ?? API_MESSAGE.INTERNAL_ERROR;
    return { isOk: false, message: errorMessage };
  }
};

export const addReview = async (
  inputReview: AddReviewDTO
): Promise<ApiResponse> => {
  try {
    console.log("api data:", inputReview);
    const { data } = await poster(`/nextapi/reviews`, inputReview);
    return { isOk: true, message: "รีวิวสินค้าสำเร็จ", data} ;
  } catch (error: any) {
    const errorMessage: string =
      error.response.data.message ?? API_MESSAGE.INTERNAL_ERROR;
    return { isOk: false, message: errorMessage };
  }
};
const encryptName = (nickname: string) => {
  const encryptedNickname = `${nickname.substring(0, 2)}*****${nickname.slice(-2)}`;
return encryptedNickname;

};

export default encryptName;
